import React, { useState } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import HeaderBar from "./HeaderBar";
import Sidebar from "./Sidebar";
import "./sidebar-menu.css";
import PrivacyPolicyGate from "src/components/PrivacyPolicyGate/PrivacyPolicyGate";

const { Content } = Layout;

interface DashboardLayoutProps {
  children?: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [privacyPolicyBlocking, setPrivacyPolicyBlocking] = useState(true);

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <HeaderBar privacyPolicyBlocking={privacyPolicyBlocking} />
      <Layout style={{ marginTop: 65, height: "calc(100vh - 80px)" }}>
        <Sidebar />
        <Content
          style={{
            padding: "24px",
            overflow: "auto",
            backgroundColor: "#f2f3f7",
          }}
        >
          {children || <Outlet />}
        </Content>
      </Layout>
      <PrivacyPolicyGate onBlockingChange={setPrivacyPolicyBlocking} />
    </Layout>
  );
};

export default DashboardLayout;
